const ACTION = {
    UPDATE_BANK_CARD_NUMBER: 'UPDATE_BANK_CARD_NUMBER',
    UPDATE_BANK_CARD_NUMBER_ERROR_TEXT: ' UPDATE_BANK_CARD_NUMBER_ERROR_TEXT',
}

export default ACTION;